export default __webpack_public_path__ + "static/media/carriage-horse.dd0620a9.jpg";